module.exports = __webpack_public_path__ + "static/assets/38cad4be6482440a44f4686e61bec5e3.svg";